import { Operator } from '../../../../../../../../services/common/Constants';
import React from 'react';
import EqualValue from './EqualValue';
import ComparisonValue from './ComparisonValue';
import SetValue from './SetValue';

const ArithmeticType = ({
  selectedOperator,
  fieldName,
  showLabel,
  availableValueOptions,
}) => {
  switch (selectedOperator) {
    case Operator.EQUAL:
    case Operator.NOT_EQUAL:
      return (
        <EqualValue
          showLabel={showLabel}
          fieldName={fieldName}
          availableValueOptions={availableValueOptions}
        />
      );
    case Operator.GREATER_THAN:
    case Operator.GREATER_OR_EQUAL:
    case Operator.LESS_THAN:
    case Operator.LESS_OR_EQUAL:
      return <ComparisonValue showLabel={showLabel} fieldName={fieldName} />;
    case Operator.BETWEEN:
      return <>{/*TODO: Two values*/}</>;
    case Operator.IS_NULL:
    case Operator.NOT_NULL:
      return <>{/*MEANS UNDEFINED*/}</>;
    case Operator.IN_SET:
    case Operator.NOT_IN_SET:
      return (
        <SetValue
          showLabel={showLabel}
          fieldName={fieldName}
          availableValueOptions={availableValueOptions}
        />
      );
    default:
      return <></>;
  }
};

export default ArithmeticType;
